import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { DataConsumer } from "../../../api";
import { useDataConsumersAll } from "../../../api/api.data-consumers";

export function DataConsumerIntegrationsTable() {
  const { t } = useTranslation();
  const history = useHistory();
  const dataConsumers = useDataConsumersAll();

  const sortedDataConsumers = (dataConsumers.value?.items || []).sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  return (
    <Table
      sticky
      dataSource={sortedDataConsumers}
      rowKey="id"
      size="middle"
      scroll={{ y: "calc(100vh - 130px)" }}
      loading={dataConsumers.loading}
      columns={[
        {
          title: t("integrations:data-consumers-title"),
          render: (c: DataConsumer) => <>{c.name}</>,
        },
      ]}
      onRow={(record) => {
        return {
          onClick: () => {
            history.push("/integrations/" + record.id);
          },
          style: {
            cursor: "pointer",
          },
        };
      }}
      pagination={false}
    />
  );
}
